import React from "react"
import {IngestionInbox} from "components/backoffice/Storage/Ingestion/Inbox"

export const IngestionInboxRoute = () => <IngestionInbox />
